import type { StyleRule } from '@archipro-design/aria';
import { captionClassName } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const CurrentLocation: StyleRule = ({ theme }) => ({
    textAlign: 'center',
    paddingTop: theme.siteVariables.spaces['space-8'],
    ['& .' + captionClassName]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    ['& .' + svgIconClassName]: {
        marginRight: theme.siteVariables.spaces['space-4'],
    },
    [theme.screen.tablet]: {
        padding: pxArrayToRem([8, 0]),
        textAlign: 'right',
        ['& .' + captionClassName]: {
            justifyContent: 'flex-end',
        },
    },
});

export const ErrorMessage: StyleRule = ({ theme }) => ({
    paddingTop: theme.siteVariables.spaces['space-8'],
    [theme.screen.tablet]: {
        color: theme.siteVariables.colors.danger[200],
    },
});
